// Phase 18 · Community · Trending widget (right rail)
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TrendingUp, ArrowUp } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function TrendingWidget({ limit = 5 }) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const r = await fetch(`${API}/api/community/trending?limit=${limit}`, { credentials: "include" });
                if (r.ok) {
                    const d = await r.json();
                    setItems(d.items || []);
                }
            } catch {}
            setLoading(false);
        })();
    }, [limit]);

    return (
        <aside
            className="w-full lg:w-72 flex-shrink-0 bg-[#111111] border border-[#1A1A1A] rounded-xl p-4 lg:sticky lg:top-4 h-fit"
            data-testid="trending-widget"
        >
            <div className="flex items-center gap-2 mb-3 pb-3 border-b border-[#1A1A1A]">
                <TrendingUp size={16} className="text-[#CCCCCC]" />
                <p className="text-sm font-semibold text-neutral-200">Trending · 7d</p>
            </div>
            {loading && <p className="text-xs text-neutral-500">Loading…</p>}
            {!loading && !items.length && (
                <p className="text-xs text-neutral-500 italic">No trending posts yet</p>
            )}
            <div className="space-y-2.5">
                {items.map((p, idx) => (
                    <Link
                        key={p.id}
                        to={`/community/post/${p.id}`}
                        className="block group"
                        data-testid={`trending-item-${idx}`}
                    >
                        <div className="flex gap-2">
                            <span className="text-lg font-mono font-bold text-neutral-600 group-hover:text-[#FFFFFF] transition-colors w-5 flex-shrink-0">
                                {idx + 1}
                            </span>
                            <div className="flex-1 min-w-0">
                                <p className="text-xs font-medium text-neutral-200 line-clamp-2 group-hover:text-[#FFFFFF] transition-colors">
                                    {p.title}
                                </p>
                                <div className="flex items-center gap-2 text-[10px] text-neutral-500 mt-0.5">
                                    <span className="inline-flex items-center gap-0.5">
                                        <ArrowUp size={10} />
                                        {p.upvotes || 0}
                                    </span>
                                    <span>·</span>
                                    <span>{p.comment_count || 0} c</span>
                                    <span>·</span>
                                    <span>@{p.author_username}</span>
                                </div>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </aside>
    );
}
